import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    activityId: null,
    priceList: [],
    statusObj: {
      '01': '报名中',
      '02': '未开始',
      '03': '已暂停',
      '04': '已结束'
    }
  },
  mutations: {
    setProductId: (state, payload) => {
      state.activityId = payload
    },
    setPriceList: (state, payload) => {
      state.priceList = payload
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js